<div *ngIf="supplier" class="detail-wrapper d-flex flex-column align-items-start justify-content-stretch">
    <div class="detail-header">
        <div class="d-flex flex-row flex-nowrap justify-content-start align-items-center">
                    <!-- <kendo-stepper [steps]="steps" [stepType]="'full'" [(currentStep)]="currentStep" [linear]="false"
                        [style.width.px]="sharedDataSvc.detailSupplierToolbarWidth" [orientation]="'horizontal'" (activate)="activateStep($event)">
                        <ng-template kendoStepperStepTemplate let-step>
                            <div class="custom-step" [ngClass]="{'selected-step':step.index==currentStep, 'custom-step-selectable': stepperIsSelectable(step),'custom-step-disabled':step.disabled && step.index!=currentStep}">
                                <div class="d-flex flex-row align-items-center justify-content-center">
                                    <div class="stepper-line flex-fill" *ngIf="step.index!=0" [ngClass]="{'stepper-line-done':stepperIsDone(step),'stepper-line-undone':!stepperIsDone(step)}">
                                    </div>
                                    <i *ngIf="step.index!=0" class="fas fa-arrow-right stepper-line-arrow" [ngClass]="{'stepper-line-arrow-done':stepperIsDone(step),'stepper-line-arrow-undone':!stepperIsDone(step)}"></i>
                                    <div class="stepper-icon"
                                        [ngClass]="{'stepper-icon-selectable': stepperIsSelectable(step)}">
                                        <kendo-svgicon *ngIf="step.svgIcon" [icon]="step.svgIcon"  size="large"></kendo-svgicon>
                                        <div *ngIf="step.faIcon" style="font-size: 28px;">
                                            <i [class]="step.faIcon"></i>
                                        </div>
                                        <img *ngIf="step.imgSrc" [src]="step.imgSrc" style="width:46px; height:50px;object-fit: contains;">
                                    </div>
                                </div>
                            </div>
                            <span class="step-label">
                                <span class="text-wrap small mr-1"
                                    [ngClass]="{'selected-step':step.index==currentStep,'custom-step-disabled':step.disabled,'text-endel-blue':!step.disabled}" [paflabel]="step.label"
                                    rescod="supplier-details">
                                </span>
                                <span *ngIf="step.index!=6 && !step.disabled" class="small">
                                    <span *ngIf="step.screenValidity.isValid==null && step.label!='Pilotage_ENDEL'" class="text-warning"><i
                                            class="fas fa-question-circle"></i></span>
                                    <span *ngIf="step.screenValidity.isValid==false" class="text-danger"><i
                                            class="fas fa-times-circle"></i></span>
                                    <span *ngIf="step.screenValidity.isValid==true" class="text-success"><i
                                            class="fas fa-check-circle"></i></span>
                                </span>
                            </span>
                        </ng-template>
                    </kendo-stepper> -->
            <kendo-stepper [steps]="steps" [stepType]="'full'" [(currentStep)]="currentStep" [linear]="false"
                [style.width.px]="900" [orientation]="'horizontal'" (activate)="activateStep($event)">
                <ng-template  kendoStepperIndicatorTemplate let-step >
                    <span *ngIf="step.svgIcon">
                        <kendo-svgicon [icon]="step.svgIcon"  size="xlarge"></kendo-svgicon>
                    </span>
                    <span *ngIf="step.iconClass">
                        <i [class]="step.iconClass"></i>
                    </span>
                    <span *ngIf="!step.svgIcon && step.imgSrc">
                        <img [src]="step.imgSrc" style="width:36px; height:36px;object-fit: contains;">
                    </span>
                </ng-template>  
                <ng-template kendoStepperLabelTemplate let-step>
                    <span class="d-flex flex-row align-items-center justify-content-center" style="width:145px;line-height: 0.75rem;">
                        <span class="text-wrap text-center flex-shrink" style="max-width:130px;line-height: 0.75rem;">
                            {{ step.label }}  
                            <span *ngIf="step.index<6 && !step.disabled" class="small text-left" style="margin-left: 1px;width:15px;">
                                <span *ngIf="step.screenValidity.isValid==null && step.label!='Pilotage_ENDEL'" class="validation-icon text-warning"><i class="fas fa-question-circle"></i></span>
                                <span *ngIf="step.screenValidity.isValid==false" class="validation-icon text-danger"><i class="fas fa-times-circle"></i></span>
                                <span *ngIf="step.screenValidity.isValid==true" class="validation-icon text-success"><i class="fas fa-check-circle"></i></span>
                            </span>   
                        </span>                   
                    </span>
                </ng-template>
            </kendo-stepper>
            <div id="rse-progress-container"></div>
            <div class="flex-fill d-flex flex-row flex-wrap justify-content-end align-items-center">
                <h2 class="flex-fill  mr-2 mt-1 align-self-stretch d-flex align-items-center justify-content-end" style="width:400px">
                    <label class="control-label text-primary supplier-title text-nowrap-ellipsis">{{supplierTitle}}</label>
                </h2>
                <supplier-validation-toolbar [supplier]="supplier" class="mr-1" style="width: 500px;"
                    (supplierStatutChanged)="supplierStatutChanged($event)"
                    [validationdisabled]="validationDisabled" (beforevalidateclick)="beforevalidateclick($event)"
                    [validationclickconfirm]="validationclickconfirmSubject.asObservable()">
                </supplier-validation-toolbar>
            </div>
        </div>
    </div>

    <div *ngIf="stepsLoaded" class="detail-main-container flex-fill">
        <div *ngIf="currentStepObject.labelCod=='Descriptif'">
            <app-supplier-descriptif 
                [ocurrentstep]="currentStepObject" [demandeur]="demandeur"
                [supplier]="supplier" 
                ></app-supplier-descriptif>
        </div>
        <div *ngIf="currentStepObject.labelCod=='Informations_comptables'">
            <app-supplier-account-info
                [ocurrentstep]="currentStepObject" 
                [supplier]="supplier"
                ></app-supplier-account-info>
        </div>
        <div *ngIf="currentStepObject.labelCod=='Savoir_faire'">
            <app-supplier-knowledge 
                [ocurrentstep]="currentStepObject"
                [supplier]="supplier" 
                ></app-supplier-knowledge>
        </div>
        <div *ngIf="currentStepObject.labelCod=='Documents_reglementaires'">
            <app-supplier-regul-docs
                [ocurrentstep]="currentStepObject"
                [supplier]="supplier"                 
                ></app-supplier-regul-docs>
        </div>
        <div *ngIf="currentStepObject.labelCod=='Documents_qualite'">
            <app-supplier-quality-docs           
                [ocurrentstep]="currentStepObject"
                [supplier]="supplier"                 
                ></app-supplier-quality-docs>
        </div>
        <div *ngIf="currentStepObject.labelCod=='RSE'">
            <app-supplier-rse          
                [ocurrentstep]="currentStepObject"
                [supplier]="supplier"                 
                ></app-supplier-rse>
        </div>
        <div *ngIf="currentStepObject.labelCod=='Recapitulatif'">
            <app-supplier-recap
                [ocurrentstep]="currentStepObject"  [demandeur]="demandeur"
                [supplier]="supplier"                
                >
            </app-supplier-recap>
        </div>
        <div  [hidden]="!(showPilotageEndel && currentStepObject.labelCod=='Pilotage_ENDEL')">
            <ng-template pilotageEndelContainer></ng-template>
        </div>
    </div>
    
    <div class="detail-footer">
        <div class="d-flex justify-content-center flex-wrap">
            <button *ngIf="showBtnSaveSupplierFolder" type="button" class="btn btn-sm btn-primary mx-1" btnDebounceClick (debounceClick)="saveFolder('close')" [debounceTime]="700"
                paflabel="saveSupplierFolder"></button>
            <button *ngIf="showSaveFolderBtn" type="button" class="btn btn-sm btn-primary mx-1" (debounceClick)="saveFolder('close')" btnDebounceClick  [debounceTime]="700"
                paflabel="Sauvegarder_le_dossier"></button>
            <button *ngIf="showPreviousBtn" type="button" class="btn btn-sm btn-primary mx-1" btnDebounceClick  [debounceTime]="700"
                (debounceClick)="saveFolder('previous')" paflabel="Ecran_precedent"></button>
            <button *ngIf="showNextButton" type="button" class="btn btn-sm btn-primary mx-1" btnDebounceClick  [debounceTime]="700"
                (debounceClick)="saveFolder('next')" paflabel="Je_continue"></button>
            <button *ngIf="showBtnEnvoiApprobation" type="button" btnDebounceClick  [debounceTime]="700"
                class="btn btn-sm btn-primary mx-1" (debounceClick)="saveFolder('end')" paflabel="Je_valide"></button>
            <button *ngIf="showBtnEnvoiComplement" type="button" btnDebounceClick  [debounceTime]="700"
                class="btn btn-sm btn-primary mx-1" (debounceClick)="saveFolder('complement')"
                paflabel="J_envoie_les_informations_complementaires"></button>
            <button *ngIf="showBtnEnvoiAuFournissseur" type="button" class="btn btn-sm btn-primary mx-1 " btnDebounceClick  [debounceTime]="700"
                (debounceClick)="saveFolder('end')" paflabel="Envoyer_au_fournisseur"></button>
            <div [hidden]="!showSaveButton">
                <button *ngIf="!saveUnlock" type="button" class="btn btn-sm btn-primary mx-1" btnDebounceClick  [debounceTime]="700"
                (debounceClick)="unlockSaveButton()" paflabel="Editer"></button>
                <button *ngIf="saveUnlock" type="button" class="btn btn-sm btn-warning mx-1" btnDebounceClick  [debounceTime]="700"
                (debounceClick)="btnUndoSaveScreenClick()" paflabel="Annuler"></button>
                <button *ngIf="saveUnlock" type="button" class="btn btn-sm btn-success mx-1" btnDebounceClick  [debounceTime]="700"
                (debounceClick)="showWindowsValid(true)" paflabel="Valider"></button>
             
            </div>
        </div>
            <pre *ngIf="sharedDataSvc.debug && !!currentStepObject">currentStepObject Index = {{currentStepObject.index}}, isEditing = {{currentStepObject.isEditing}}</pre>
            <pre style="max-height:300px;overflow: scroll;" *ngIf="sharedDataSvc.debug && !!supplier">Supplier = {{supplier | json}}</pre>
    </div>
</div>

<kendo-window [(state)]="windowsValid.state" *ngIf="windowsValid.visible == true"
    [(width)]="windowsValid.width" [(height)]="windowsValid.height" (close)="showWindowsValid(false)">

    <kendo-window-titlebar>
        <div class="k-window-title text-center">
            <paflabel class="control-label" lblCod="Validation_modification_fournisseur"></paflabel>
        </div>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <div class="d-flex flex-column justify-content-center" style="height:100%;width:100%;">
        <div class="card">
            <div class="card-body">
                <form id="frmValidSupplier" name="frmValidSupplier" #ngfrmValidSupplier="ngForm">                    
                    <div class="row mt-3">
                        <div class="col-3">
                            <label class="control-label" paflabel="Commentaire"></label>
                        </div>
                        <div class="col-9">
                            <textarea style="width:100%;height:120px;" class="form-control" name="comments" [(ngModel)]="validationComment"></textarea>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div style="width:100%;" class="text-center my-2">
            <button type="button" paflabel="Annuler" class="btn btn-sm btn-warning mx-1"
                (click)="showWindowsValid(false)"></button>
            <button type="button" paflabel="Valider" class="btn btn-sm btn-success mx-1" [disabled]="ngfrmValidSupplier.invalid" (click)="btnWindowCommentSaveClick(validationComment)"></button>
        </div>
    </div>
</kendo-window>
